// Tabs controller for tabbed interfaces
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { defaultTab: String }

  connect() {
    // Check URL query param first, then hash, then default tab value, then first tab
    const urlParams = new URLSearchParams(window.location.search)
    const queryTab = urlParams.get('tab')
    const hashTab = window.location.hash?.replace('#', '')
    const defaultTab = queryTab || hashTab || this.defaultTabValue || this.tabTargets[0]?.dataset.tabId
    if (defaultTab) {
      this.switchTab(defaultTab)
    }
  }

  switch(event) {
    event.preventDefault()
    const tabId = event.currentTarget.dataset.tabId
    this.switchTab(tabId)
  }

  switchTab(tabId) {
    // Hide all panels and remove active state from tabs
    this.panelTargets.forEach(panel => {
      panel.classList.add("hidden")
    })
    this.tabTargets.forEach(tab => {
      tab.classList.remove("border-indigo-500", "text-indigo-600", "dark:text-indigo-400")
      tab.classList.add("border-transparent", "text-gray-500", "hover:text-gray-700", "hover:border-gray-300", "dark:text-gray-400", "dark:hover:text-gray-300")
    })

    // Show selected panel and activate tab
    const selectedPanel = this.panelTargets.find(panel => panel.dataset.tabId === tabId)
    const selectedTab = this.tabTargets.find(tab => tab.dataset.tabId === tabId)

    if (selectedPanel) {
      selectedPanel.classList.remove("hidden")
    } else {
      console.warn('[Tabs] Panel not found for tab:', tabId)
    }
    if (selectedTab) {
      selectedTab.classList.remove("border-transparent", "text-gray-500", "hover:text-gray-700", "hover:border-gray-300", "dark:text-gray-400", "dark:hover:text-gray-300")
      selectedTab.classList.add("border-indigo-500", "text-indigo-600", "dark:text-indigo-400")
    }

    // Update URL hash without scrolling
    if (history.pushState) {
      history.pushState(null, null, `#${tabId}`)
    }
  }
}

